import React from 'react';
import MiniBarChart from './MiniBarChart';

function GivingCard({ giving, viewHref }) {
  if (!giving || giving.count <= 0) return null;

  const bars = (giving.by_year || []).map((y) => ({
    label: `'${String(y.year).slice(2)}`,
    value: y.amount,
  }));

  const currencyFormatter = (value) => `$${(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <div className="cdp-card">
      <div className="cdp-card-header-row">
        <h2 className="cdp-card-title">Giving</h2>
        {viewHref && <a href={viewHref} className="cdp-card-view-link">View all</a>}
      </div>

      <div className="cdp-stat-value">{giving.total}</div>
      <div className="cdp-stat-label">lifetime across {giving.count} gift{giving.count === 1 ? '' : 's'}</div>

      <MiniBarChart bars={bars} color="var(--sl-fg-brand)" valueFormatter={currencyFormatter} />

      {giving.last && (
        <div className="cdp-card-footer">
          Last gift {giving.last.amount} on {giving.last.date} · largest {giving.largest}
        </div>
      )}
    </div>
  );
}

export default GivingCard;
